// The answer of an item- or location-type import (Settings), as toasts:
// what was imported, then the errors, if any, kept until dismissed.
export function showImportResult(toast, t, data) {
  toast.success(t('settings.importSummary', { imported: data.imported, skipped: data.skipped }), { title: t('settings.importDoneTitle') });
  const errors = data.errors || [];
  if (errors.length > 0) {
    toast.error(errors.join('\n'), { title: t('settings.importErrors', { count: errors.length }), duration: 0 });
  }
}
